import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import VTooltip from 'v-tooltip'

import Autocomplete from 'v-autocomplete'
import Ls from './services/ls'
import Delta from 'quill-delta'
import VCollapse from './components/collapse/VCollapse'
import VCollapseItem from './components/collapse/VCollapseItem'
import VueQuillEditor from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component'
import ImgInputer from 'vue-img-inputer'
import Quill from 'quill'
import ImageResize from 'quill-image-resize-module'
import ImageUploader from 'quill-image-uploader'
import VueButtonSpinner from 'vue-button-spinner'
import { VueMaskDirective } from 'v-mask'
import vSelect from 'vue-select'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import htmlEditButton from 'quill-html-edit-button'
/**
 * Global CSS imports
 */
import 'vue-tabs-component/docs/resources/tabs-component.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'vue-img-inputer/dist/index.css'
import 'v-autocomplete/dist/v-autocomplete.css'
import 'vue-select/dist/vue-select.css'

Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/imageUploader', ImageUploader)
Quill.register('modules/htmlEditButton', htmlEditButton)

var Size = Quill.import('attributors/style/size')
Size.whitelist = [
  '10px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '24px',
  '30px',
  '32px',
  '36px'
]
Quill.register(Size, true)

var FontAttributor = Quill.import('attributors/class/font')
FontAttributor.whitelist = ['akkurat', 'arial']
Quill.register(FontAttributor, true)

const Clipboard = Quill.import('modules/clipboard')

class PlainTextClipboard extends Clipboard {
  onPaste (e) {
    if (e.defaultPrevented || !this.quill.isEnabled()) return
    let range = this.quill.getSelection()
    let delta = new Delta().retain(range.index)

    if (e && e.clipboardData && e.clipboardData.types && e.clipboardData.getData) {
      let text = (e.originalEvent || e).clipboardData.getData('text/plain')
      let cleanedText = this.convert(text)

      // Stop the data from actually being pasted
      e.stopPropagation()
      e.preventDefault()

      // Process cleaned text
      delta = delta.concat(cleanedText).delete(range.length)
      this.quill.updateContents(delta, Quill.sources.USER)
      // range.length contributes to delta.length()
      this.quill.setSelection(delta.length() - range.length, Quill.sources.SILENT)

      return false
    }
  }
}

Quill.register('modules/clipboard', PlainTextClipboard)

/**
 * Global plugins
 */
global.toastr = require('toastr')

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

global.Vue = Vue

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

/**
 * Global Axios Request Interceptor
 */

global.axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const AUTH_TOKEN = Ls.get('auth.token')

    if (AUTH_TOKEN) {
      config.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`
    }

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// global.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// })

/**
 * Custom Directives
 */
require('./helpers/directives')

/**
 * Global Components
 */
Vue.component('v-collapse', VCollapse)
Vue.component('v-collapse-item', VCollapseItem)
Vue.component('ImgInputer', ImgInputer)
Vue.component('vue-button-spinner', VueButtonSpinner)
Vue.component('v-select', vSelect)
Vue.component('vue-bootstrap4-table', VueBootstrap4Table)

Vue.directive('mask', VueMaskDirective)

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.use(VueRouter)
Vue.use(flatPickr)
Vue.use(VTooltip)
Vue.use(Vuelidate)
Vue.use(VueQuillEditor, {
  // theme: 'bubble',
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [
        {
          size: [
            false,
            '10px',
            '12px',
            '14px',
            '16px',
            '18px',
            '20px',
            '24px',
            '30px',
            '32px',
            '36px'
          ]
        }
      ],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ font: [false, 'akkurat', 'arial'] }],
      [{ align: [] }],
      ['image'],
      ['link'],
      ['clean']
    ],
    imageResize: {
      modules: ['Resize', 'DisplaySize', 'Toolbar']
    },
    imageUploader: {
      upload: file => {
        return new Promise((resolve, reject) => {
          let formData = new FormData()

          formData.append('image', file)

          global.axios
            .post('/api/admin/upload', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then(response => {
              if (response && response.data && response.data.result === 'ok') {
                global.toastr['success']('Image uploaded successfull')
                resolve(response.data.src)
              } else {
                let message =
                  (response && response.data && response.data.message) ||
                  'Something goes wrong'
                global.toastr['error'](message)
                reject(message)
              }
            })
            .catch(error => {
              let message = (error && error.message) || 'Something goes wrong'
              global.toastr['error'](message)
              reject(message)
            })
        })
      }
    },
    htmlEditButton: {}
  }
})
Vue.use(Autocomplete)
